import { Outlet } from "react-router-dom";
import Logo from "../assets/images/MarTrak.jpg"
import { useUser } from "../contexts/UserContext";
import { useNavigate, useLocation } from 'react-router-dom';
import { useUnsavedChanges } from "../contexts/UnsavedChangesContext";
import Sidebar from "../components/ui/sidebar/Sidebar"
import { Button } from "@components/ui/buttons/Button";
import { useSidebar } from "@contexts/SidebarContext";

export const MainLayout = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const { logout, user, hasSpeedApprovalIndicator } = useUser();
    const {hasUnsavedChanges, requestConfirm} = useUnsavedChanges()
    const {isMobile, isOpen, setIsOpen} = useSidebar()

    const showSpeedApprovalIndicator = Object.values(hasSpeedApprovalIndicator).some(Boolean);

    const iconClasses = "font md:text-2xl sm:text-lg text-purple-800 hover:text-purple-900 hover:cursor-pointer"

    const nonProtectedRoutes = ["/login", "/resetpassword", "/signup", "/speed", "/accessjob", "/signup/accessjob"];

    const showSidebar = !nonProtectedRoutes.includes(location.pathname) && location.pathname !== "/"

    //check if there were any unsaved changes on current page before navigating to home menu
    const handleNavigate = async(path) => {
        if(hasUnsavedChanges){
            const isConfirmed = await requestConfirm("This page has unsaved work - are you sure you want to cancel?")

            if(!isConfirmed) return;
        }
        navigate(path);
    }

    return(

            <div className="flex min-h-screen"> 
          
              {/* sidebar - only show when logged in, sits beside header, main, and footer */}
              {showSidebar &&
              (
                <div className="min-h-screen fixed top-0 bottom-0 z-50">
                    <Sidebar />
                </div>
              )}
          
              {/* page content */}
              <div className="flex flex-col flex-1 min-h-screen overflow-y-auto">


                {!nonProtectedRoutes.includes(location.pathname) ? (
                    <header className={`flex justify-between items-center martrak-header-height fixed top-0 left-0 right-0 bg-white ${location.pathname !== "/" && 'shadow-md'} z-40`}>
                        {/* Left side */}
                        <div className="flex items-center">
                        
                            {isMobile ? (
                                location.pathname === "/" ? (
                                // home page on mobile view: show logo
                                <div className="w-36 m-4">
                                    <img
                                        src={Logo}
                                        alt="MarTrak logo"
                                        onClick={() => handleNavigate('/')}
                                        className="martrak-logo-header-height"
                                    />
                                </div>
                                ) : (
                                // other pages on mobile view, show hamburger menu icon (and speed approval icon if needed)
                                !isOpen && (
                                    <button onClick={() => setIsOpen(!isOpen)} className="ml-[10vw] relative inline-flex items-center">
                                        <i className={`fa-solid fa-bars ${iconClasses}`} />

                                        { showSpeedApprovalIndicator === true && <i className={`fa-solid fa-bell text-amber-500 text-sm text-[12px] absolute -top-1.5 -right-2 pointer-events-none `}></i>}
                                    </button>
                                )
                                )
                            ) : (
                                // desktop home page: show logo
                                location.pathname === "/" && (
                                <div className="w-48 ml-[3vw]">
                                    <img
                                        src={Logo}
                                        alt="MarTrak logo"
                                        onClick={() => handleNavigate('/')}
                                        className="martrak-logo-header-height"
                                    />
                                </div>
                                )
                            )}
                        </div>

                        {/* Right side */}
                        <div className={`flex items-center ${isMobile ? "mr-[10vw]" : "mr-[3vw]"}`}>

                            <div className="text-sm font-semibold">
                                {user?.First_Name ? `Welcome, ${user.First_Name}` : "Welcome!"}
                            </div>
                           

                            {/* show logout button on all desktop pages; only show in sidebar for mobile*/}
                            {!isMobile && (
                                <Button
                                    onClick={() => logout()}
                                    variant="border"
                                    className="ml-4"
                                    size="border"
                                >
                                    Log out
                                </Button>
                            )}
                        </div>
                    </header>
                    ) : (
                    // non-protected route (e.g., login)
                    <header className="flex justify-center">
                        <div className="w-96 mt-16 mb-4 xl:mb-12 mx-2">
                        <img
                            src={Logo}
                            alt="MarTrak logo"
                            onClick={() => navigate('/login')}
                            className="w-full"
                        />
                        </div>
                    </header>
                )}


                <main className={`flex-1 min-h-max martrak-main-top-margin ${showSidebar && !isMobile && 'ml-16'}`}>
                  <Outlet />
                </main>
          
                {!nonProtectedRoutes.includes(location.pathname) && (
                  <footer className="w-full bg-purple-950" style={{ height: "7vh" }}></footer>
                )}
              </div>
            </div>
          

    )
}